let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9qELt")).then(() => parcelRequire('9QxdF'));